import { render, staticRenderFns } from "./Recebimento.vue?vue&type=template&id=100ccf38&"
import script from "./Recebimento.vue?vue&type=script&lang=js&"
export * from "./Recebimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports